import emailjs from '@emailjs/browser';

// EmailJS 설정 - 실제 서비스 ID, 템플릿 ID, 공개 키를 환경 변수로 관리
const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID';
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID';
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY';

export const sendContactEmail = async (formData) => {
  try {
    // EmailJS 초기화
    emailjs.init(PUBLIC_KEY);

    // 이메일 템플릿 파라미터
    const templateParams = {
      company_name: formData.companyName,
      contact_person: formData.contactPerson,
      email: formData.email,
      phone: formData.phone,
      project_type: formData.projectType,
      budget: formData.budget,
      timeline: formData.timeline,
      description: formData.description,
      to_email: 'naldadev@gmail.com', // 수신 이메일
    };

    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error('Email send failed:', error);
    return { success: false, error };
  }
};

// 로컬 스토리지에 폼 데이터 자동 저장
export const saveFormToLocalStorage = (formData) => {
  try {
    localStorage.setItem('contactFormDraft', JSON.stringify({
      data: formData,
      timestamp: new Date().toISOString()
    }));
  } catch (error) {
    console.error('Failed to save form data:', error);
  }
};

// 로컬 스토리지에서 폼 데이터 불러오기
export const loadFormFromLocalStorage = () => {
  try {
    const saved = localStorage.getItem('contactFormDraft');
    if (saved) {
      const { data, timestamp } = JSON.parse(saved);
      // 7일 이상 된 데이터는 무시
      const daysSince = (new Date() - new Date(timestamp)) / (1000 * 60 * 60 * 24);
      if (daysSince < 7) {
        return data;
      }
    }
  } catch (error) {
    console.error('Failed to load form data:', error);
  }
  return null;
};

// 폼 제출 후 로컬 스토리지 클리어
export const clearFormFromLocalStorage = () => {
  try {
    localStorage.removeItem('contactFormDraft');
  } catch (error) {
    console.error('Failed to clear form data:', error);
  }
};